<template>
  <div class="order" v-show="show">
    <div class="order_status">
      <p class="status_p1">{{ getName(listData2.state, "status") }}</p>
      <p class="status_p2">{{ getName(listData2.state, "describe") }}</p>
    </div>
    <div class="content address_content">
      <p class="address_name">
        <span>{{ listData2.addressee }}</span>
        <span>{{ listData2.phone }}</span>
      </p>
      <p class="address_add">{{ listData2.address }}</p>
    </div>
    <div class="prescription-content">
      <p class="title">{{listData2.name}}</p>
      <p class="prescription"><span v-for="(medicine,index) in JSON.parse(listData2.content)" :key="index">{{medicine.name}}{{medicine.quantity}}{{unitFormat(medicine.unit)}} </span></p>
      <div class="num">
        帖数：{{listData2.num}}帖
      </div>
    </div>
    <div class="content detail_content">
      <p class="detail_p1">
        订单编号
        <span>{{ listData2.out_trade_no }}</span>
      </p>
      <p class="detail_p1">
        下单时间
        <span>{{ distance(listData2.created_time) }}</span>
      </p>
    </div>

    <div class="content charging_content">
      <p class="charging_p1">
        药费
        <span>￥{{priceFormat(listData2.price)}}</span>
      </p>
      <p class="charging_p1">
        运费
        <span
          >￥{{ listData2.postage }}</span
        >
      </p>
      <p class="charging_p2">
        合计
        <span>￥{{totalFormat(listData2.price, listData2.postage)}}</span>
      </p>
    </div>
    <div class="submit_content" v-show="listData2.state == 0">
      <button class="buynow" @click="show_pay = true">去付款</button>
    </div>
    <van-popup
      class="express_content"
      v-model="show_express"
      position="bottom"
      round
      :style="{ height: '30%' }"
    >
      <p class="express_head">
        <span class="express_cancel" @click="show_express = false">取消</span>
        选择配送方式
        <span
          class="express_determine"
          @click="
            (export_index = pre_export_index),
              (show_express = false),
              getmoney()
          "
          >确定</span
        >
      </p>
      <ul class="express_ul">
        <li
          v-for="(item, index) in distribution"
          :key="index"
          class="express_li"
          @click="pre_export_index = index"
        >
          <img
            :src="require('../../assets/images/order/icon' + index + '.png')"
            alt
          />
          <p>
            {{ item.name }}
            <br />
            <span>{{ item.details }}</span>
          </p>
          <div
            :class="[
              { express_icon_active: index == pre_export_index },
              'express_icon',
            ]"
          ></div>
        </li>
      </ul>
    </van-popup>
    <!-- 支付选择弹窗 -->
    <van-popup
      class="express_content"
      v-model="show_pay"
      position="bottom"
      round
      :style="{ height: '85%' }"
    >
      <p class="express_head">
        <span class="express_cancel" @click="show_pay = false">取消</span>
        选择支付方式
        <!-- <span class="express_determine" @click="export_index=pre_export_index,show_pay=false,getmoney()">确定</span> -->
      </p>
      <ul class="express_ul">
        <li
          v-for="(item, index) in payment"
          :key="index"
          class="express_li"
          @click="pre_pay_index = index"
          v-show="item.isshow"
        >
          <img
            :src="
              require('../../assets/images/order/pay_icon' + index + '.png')
            "
            alt
          />
          <p class="pay_p">{{ item.name }}</p>
          <div
            :class="[
              { express_icon_active: index == pre_pay_index },
              'express_icon',
            ]"
          ></div>
        </li>
      </ul>
      <button class="buynow" @click="orderup">确认</button>
    </van-popup>
  </div>
</template>
<script>
import {_} from 'vue-underscore';
import { deviceType } from "../../util/deviceType";
import http from "../../util/pontusApiConfig";
import http2 from "../../util/gaeaApiConfig";
export default {
  data() {
    return {
      show: false,
      statusArr: {},
      statuslistArr: [
        {
          code: 0,
          status: "待支付",
          describe:
            "您已提交药品订单，请在14分18秒内完成支付，超时未支付订单自动关闭",
        },
        {
          code: 1,
          status: "已支付",
          describe: "等待药房接单",
        },
        {
          code: 2,
          status: "药房已接单",
          describe: "药房已接单，将会尽快为您准备药品",
        },
        {
          code: 3,
          status: "配送中",
          describe: "物流信息",
        },
        {
          code: 4,
          status: "已签收/已完成",
          describe: "物流信息",
        },
        {
          code: 5,
          status: "已退款（药房退单）",
          describe: "因药房退单，已为您做退款处理，如有疑问请联系客服",
        },
        {
          code: 6,
          status: "已退款（系统退单）",
          describe: "因系统退单，已为您做退款处理，如有疑问请联系客服",
        },
        {
          code: 7,
          status: "已退款（超时未审核）",
          describe: "因药房超时未审核，已为您做退款处理，如有疑问请联系客服",
        },
        {
          code: 8,
          status: "已取消（超时未支付）",
          describe: "因超时未支付，订单已取消",
        },
      ],
      listData: {},
      listData2: {},
      pharmacy: {
        name: "北京·康美药业",
        detail: "专业从事中药配方颗粒研究和生产15年",
        tips: "17:00前下单，当日寄出",
      },
      show_express: false,
      export_index: 0,
      pre_export_index: 0,
      distribution: [
        {
          name: "顺丰快递",
          details: "药费满¥100包邮，90%地区次日送达",
          money: 0,
        },
      ],
      show_pay: false,
      pre_pay_index: 0,
      payment: [
        {
          name: "支付宝支付",
          isshow: true,
        },
        {
          name: "微信支付",
          isshow: true,
        },
      ],
      // 是否提供代煎选择
      isprovide: true,
      // 是否代煎
      isdecocting: false,
      // 可以代煎
      candecocting: false,
      amountOfMoney: 0,
      charging: {
        // 药费
        drugcost: 0,
        // 运费
        freight: 15,
        // 优惠费
        discount: 0,
        // 代煎费
        decoctingfee: 0,
      },
      is_choise_coupon: 3,
      coupon_count: 0,
      // 供应商id
      provider_id: null,
      user_id: 1,
      order_id: 2,
      openid: false,
      token: "",
      appid: "wxcc7ab5ca954203d8",
      is_weixin: deviceType.isWeiXin,
      is_app: deviceType.isApp,
      is_ios_app: deviceType.isIOSApp,
      is_android_app: deviceType.isAndroidApp,
      is_Patient: deviceType.isPatient
    };
  },
  created() {
    var user_info = this.$appUtils.appData();
    if (user_info) {
      this.user_id = user_info.user_id;
      this.token = user_info.token;
    } else {
      if (localStorage.getItem("user_id")) {
        this.user_id = localStorage.getItem("user_id");
      }
      if (localStorage.getItem("token")) {
        this.token = localStorage.getItem("token");
      }
    }
    var order_id = this.$route.query.order_id;
    if (order_id) {
      this.order_id = order_id;
    }
    this.getstatus();
    window.appBack = () => this.pageback();
  },
  methods: {
    priceFormat(price){
        return (price/100).toFixed(2);
    },
    totalFormat(price, postage){
        if(price < 10000){
          price = price + postage
        }
        return (price/100).toFixed(2);
    },
    unitFormat(unit){
        if(unit == '克'){
            return 'g';
        }
        return unit;
    },
    getName(id, key){
      var item = _.filter(this.statuslistArr, function(selector){ return selector.code == id; })[0];
      if(item){
          return item[key];
      }else{
          return '';
      }
    },
    getstatus() {
      let that = this;
      let url = "users/" + this.user_id + "/orders/" + this.order_id;
      let params = {
        order_type: "drug",
      };
      http
        .get(
          url,
          { params },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: this.token,
            },
          }
        )
        .then(function (res) {
          if (res.data.status_code == 200) {
            that.listData2 = res.data.data;
            that.show = true;
            that.$appUtils.appCloseLoadingView();
          }
        });
    },
    getArea(arr) {
      let str = "";
      if (arr) {
        arr = JSON.parse(arr);
        // console.log(arr);
        for (let i = 0; i < arr.length; i++) {
          if (i == 0) {
            str = arr[i]["name"];
          } else {
            str = str + " " + arr[i]["name"];
          }
          if (i == 1) {
            if (
              arr[i].id == 230 &&
              arr[i].code == "440100" &&
              arr[i].name == "广州市"
            ) {
              this.distribution[0].money = 10;
              this.charging.freight = 10;
            } else {
              this.distribution[0].money = 20;
              this.charging.freight = 20;
            }
          }
        }
      }
      return str;
    },
    getData() {
      let that = this;
      var iss = true;
      if (iss) {
        this.candecocting = true;
        this.isdecocting = false;
      } else {
        this.candecocting = false;
        this.isdecocting = false;
      }
      let iss2 = this.is_choise_coupon;
      if (iss2 == 1) {
        this.coupon_count = 4;
        this.charging.discount = 0;
      } else if (iss2 == 2) {
        this.coupon_count = 0;
        this.charging.discount = 20;
      } else {
        this.coupon_count = 0;
        this.charging.discount = 0;
      }
      this.pre_export_index = this.export_index;
      this.getmoney();
      // this.choise_coupon()
    },
    getcoupon() {
      let that = this;
      let params = {
        use_type: "drug",
        provider_id: "2",
      };
      let url = "users/" + this.user_id + "/coupons/can_use";
      http
        .get(
          url,
          { params },
          {
            headers: {
              Authorization: this.token,
            },
          }
        )
        .then(function (res) {
          // console.log(res.data)
          that.coupon_count =
            res.data.data.drug_discount.length +
            res.data.data.drug_reduce.length;
          if (that.coupon_count > 0) {
            that.is_choise_coupon = 1;
          } else {
            that.is_choise_coupon = 3;
          }
        });
    },
    getmoney() {
      let money = this.charging.drugcost;
      this.charging.freight = this.distribution[this.export_index].money;
      // 代煎
      if (this.isdecocting && this.isprovide) {
        this.charging.decoctingfee = this.listData.prescription.total_count * 2;
        money += this.charging.decoctingfee;
      }
      // 满百免邮
      if (this.charging.drugcost < 100) {
        money += this.charging.freight;
      }
      // 优惠减价
      if (this.charging.discount > 0) {
        money -= this.charging.discount;
      }
      this.amountOfMoney = money;
      // console.log(money);
    },
    // 选择优惠券
    change_coupon() {},
    distance(day) {
      //过去的时间戳
      var now = new Date(day * 1000); //过去 //年
      var year = now.getFullYear(); //月
      var month = now.getMonth() + 1; //日
      var date = now.getDate(); //时
      var hour = now.getHours(); //分
      var minute = now.getMinutes(); //秒
      var second = now.getSeconds();
      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      var timer =
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second;

      return timer;
    },
    getOpenid(code) {
      let that = this;
      let params = { code: code };
      http2.get("/users/oauth/user", { params: params }).then(function (res) {
        if (res.data.status_code == 200) {
          that.openid = res.data.data.openid;
          localStorage.setItem("openid", that.openid);
        }
      });
    },
    orderup() {
      let that = this;
      let params = {
        order_type: "drug",
        address: this.listData2.address,
        addressee: this.listData2.addressee,
        phone: this.listData2.phone,
        name: this.listData2.name,
        content: this.listData2.content,
        num: this.listData2.num,
        postage: this.listData2.postage,
        return_url: window.location.origin + "/medicineorderresult",
      };
      if(this.is_ios_app){
        params['channel'] = 'ios';
      }else if(this.is_android_app){
        params['channel'] = 'android';
      }else{
        params['channel'] = 'wap';
      }
      if (this.is_app) {
        if (this.pre_pay_index == 0) {
          params["scene"] = 1;
          params["pay_type"] = "ali_app";
        } else {
          params["scene"] = 0;
          params["pay_type"] = "wx_app";
        }
        params['return_url'] = window.location.origin + "/medicineorderdetail"
        that.$appUtils.appPay(params);
      } else {
        if (this.pre_pay_index == 0) {
          params["pay_type"] = "ali_wap";
        } else {
          if (this.is_weixin) {
            params["pay_type"] = "wx_js";
            params["openid"] = this.openid;
          } else {
            params["pay_type"] = "wx_h5_wap";
          }
        }
        this.toPay(params);
      }
    },
    toPay(params) {
      let that = this;
      //  / users/"+that.user_id+"/order
      http
        .post("/users/" + that.user_id + "/order", params, {
          headers: { Authorization: that.token },
        })
        .then(function (res) {
          console.log(res);
          if (res.data.status_code == 200) {
            localStorage.setItem("out_trade_no", res.data.data.out_trade_no);
            if (params["pay_type"] == "ali_wap") {
              window.location.href = res.data.data.pay_params;
            } else if (params["pay_type"] == "wx_h5_wap") {
              window.location.href =
                res.data.data.pay_params.mweb_url +
                "&redirect_url=" +
                params["return_url"];
            } else if (params["pay_type"] == "wx_js") {
              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener(
                    "WeixinJSBridgeReady",
                    that.onBridgeReady(res.data.data.pay_params),
                    false
                  );
                } else if (document.attachEvent) {
                  document.attachEvent(
                    "WeixinJSBridgeReady",
                    that.onBridgeReady(res.data.data.pay_params)
                  );
                  document.attachEvent(
                    "onWeixinJSBridgeReady",
                    that.onBridgeReady(res.data.data.pay_params)
                  );
                }
              } else {
                that.onBridgeReady(res.data.data.pay_params);
              }
            }
          }
        });
    },
    onBridgeReady(data) {
      let that = this;
      window.WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: data.appId, // 公众号名称，由商户传入
          timeStamp: data.timeStamp, // 时间戳，自1970年以来的秒数
          nonceStr: data.nonceStr, // 随机串
          package: data.package,
          signType: data.signType, // 微信签名方式：
          paySign: data.paySign, // 微信签名
        },
        function (res) {
          // alert(JSON.stringify(res));
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            window.location.href = window.location.origin + "/orderresult";
          }
        }
      );
    },
    pageback() {
      window.history.back();
      return true;
    },
  },
  watch: {
    isdecocting(val) {
      this.getmoney();
    },
  },
};
</script>
<style lang="scss" scoped>
.prescription-content{
  width: calc(100% - 50px);
  margin: 0 auto 10px;
  padding: 20px 10px;
  background-color: #ffffff;
  box-shadow: 0px 2px 5px 1px rgba(35, 24, 21, 0.15);
  border-radius: 10px;
  .title{
    line-height: 16px;
    font-size: 16px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    color: #666666;
  }
  .prescription{
    margin-top: 10px;
    padding-bottom: 7px;
    line-height: 24px;
    font-size: 14px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: #333333;
    border-bottom: 1px solid #f2f2f2;
  }
  .num{
    margin-top: 20px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: #333333;
    position: relative;
    input{
      padding: 0;
      width: 28px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      font-family: PingFang-SC-Bold;
      font-weight: bold;
      color: #AC4B38;
      text-align: center;
      background: #EDEDED;
      border: 0;
      border-radius: 0;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 26px;
    }
    .reduce,
    .plus{
      display: block;
      width: 24px;
      height: 24px;
      background: #EDEDED;
      border-radius: 2px;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      cursor: pointer;
    }
    .reduce{
      right: 56px;
    }
    .plus{
      right: 0;
    }
    .reduce::before,
    .plus::before{
      content: '';
      display: block;
      width: 12px;
      height: 1px;
      background: #4D4D4D;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
    .plus::after{
      content: '';
      display: block;
      width: 1px;
      height: 12px;
      background: #4D4D4D;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
    .grey::before{
      background: #999999;
    }
  }
}
.order {
  padding-top: 10px;
  background: url('../../assets/images/order/detail_title.png') no-repeat 0px 0px;
  background-size: 100% 152px;
  .order_status {
    height: 92px;
    background: url("../../assets/images/order/icon_order.png") no-repeat 16px 28px;
    background-size: 28px 28px;
    box-sizing: border-box;
    padding: 16px 0px 0px 66px;
    .status_p1 {
      font-size: 20px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: #ffffff;
    }
    .status_p2 {
      margin-top: 2px;
      width: 85%;
      font-size: 12px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .content {
    width: calc(100% - 30px);
    background: rgba(255, 255, 255, 1);
    box-shadow: 3px 3px 12px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 20px 10px;
    margin: 0 auto;
    margin-bottom: 10px;
    color: #333;
    .content_title {
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      .distribution_p1 {
        font-size: 14px;
        float: right;
        margin-right: 17px;
        &::after {
          content: "";
          display: inline-block;
          width: 16px;
          height: 16px;
          margin-left: 6px;
          background: url("../../assets/images/order/more.png") no-repeat center
            center;
          background-size: cover;
          vertical-align: text-top;
        }
      }
    }
  }
  .address_content {
    height: 80px;
    padding-left: 60px;
    position: relative;
    background: #fff url("../../assets/images/order/address_icon.png") no-repeat
      10px center;
    background-size: 40px 40px;
    p {
      width: 100%;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .address_add {
      color: #666;
    }
  }
  .pharmacy_content {
    .pharmacy_content2 {
      width: 100%;
      box-sizing: border-box;
      padding-left: 54px;
      margin-top: 10px;
      background: url("../../assets/images/order/yaofang.png") no-repeat 0px 5px;
      background-size: 44px 44px;
      .pharmacy_p1 {
        font-size: 14px;
        color: #333;
        font-weight: 500;
        ins{
          width: 12px;
          height: 12px;
          display: inline-block;
          background: url('../../assets/images/order/i.png') no-repeat center center;
          background-size: cover;
          margin-left: 5px;
        }
      }
      .pharmacy_p2 {
        font-size: 12px;
        color: #999;
        margin-top: 3px;
      }
      .decocting_chiose {
        display: flex;
        justify-content: space-between;
        margin-top: 9px;
        .chiose_p {
          width: 128px;
          height: 40px;
          line-height: 40px;
          color: #999999;
          font-size: 14px;
          box-shadow: 0px -1px 0px 0px rgba(244, 244, 244, 1);
          border-radius: 8px;
          border: 1px solid rgba(153, 153, 153, 1);
          text-align: center;
        }
        .diy_active {
          border: 1px solid #ac4b38;
          color: #ac4b38;
        }
        .diy_active.chiose_p1::before {
          background: url("../../assets/images/order/diy_pre.png") no-repeat
            center center;
          background-size: cover;
        }
        .diy_active.chiose_p2::before {
          background: url("../../assets/images/order/medicine_pre.png")
            no-repeat center center;
          background-size: cover;
        }
        .chiose_p1 {
          &::before {
            content: "";
            width: 24px;
            height: 24px;
            display: inline-block;
            background: url("../../assets/images/order/diy_nor.png") no-repeat
              center center;
            background-size: cover;
            vertical-align: middle;
            margin-right: 12px;
          }
        }
        .chiose_p2 {
          &::before {
            content: "";
            width: 24px;
            height: 24px;
            display: inline-block;
            background: url("../../assets/images/order/medicine_nor.png")
              no-repeat center center;
            background-size: cover;
            vertical-align: middle;
            margin-right: 12px;
          }
        }
      }
    }
  }
  .distribution_content {
    .distribution_p2 {
      font-size: 12px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      text-align: right;
      padding-right: 17px;
    }
  }
  .prescription_content {
    background: url("../../assets/images/order/background_prescription.png")
      no-repeat top center;
    background-size: 100% 92px;
    .personal {
      height: 92px;
      padding: 37px 10px 14px 10px;
      box-sizing: border-box;
      // background: rgba(255, 242, 242, 1);
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #fff;
      position: relative;
      border-radius: 8px 8px 0px 0px;
      &::before {
        content: "处方";
        width: 100%;
        display: block;
        text-align: center;
        position: absolute;
        top: 0px;
        font-size: 16px;
      }
    }
    .content2 {
      padding-bottom: 12px;
      border-bottom: 1px solid #FEF2F0;
      .head_title {
        width: 100%;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        position: relative;
        margin-top: 12px;
        margin-bottom: 6px;
        &::before {
          content: "";
          display: block;
          width: 4px;
          height: 16px;
          background: #DE654C;
          position: absolute;
          top: 4px;
          left: -10px;
        }
        .ask {
          float: right;
          padding: 4px 8px;
          border-radius: 4px;
          text-align: center;
          font-size: 12px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #ac4b38;
          line-height: 17px;
          &::before {
            content: "";
            display: inline-block;
            width: 15px;
            height: 15px;
            background: url("../../assets/images/order/msg.png") no-repeat
              center center;
            background-size: cover;
            vertical-align: text-top;
            margin-right: 5px;
          }
        }
      }
      .content_details {
        font-size: 14px;
        color: #666;
        .medicament_li {
          display: inline-block;
          margin-right: 6px;
        }
      }

      .medicament_li_tips1 {
        font-size: 12px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #999999;
        line-height: 25px;
        text-align: center;
      }
      .medicament_li_tips2 {
        padding: 20px 0px;
      }
    }
  }
  .bn {
    border-bottom: none !important;
    padding-bottom: 0 !important;
  }
  .detail_content {
    .detail_p1 {
      font-size: 12px;
      margin-bottom: 10px;
      color: #999999;
      span {
        float: right;
      }
    }
  }
  .charging_content {
    .charging_p1 {
      font-size: 14px;
      margin-bottom: 10px;
      color: #333333;
      margin-bottom: 13px;
      span {
        float: right;
      }
      .del_active {
        text-decoration: line-through;
      }
      .coupon_count {
        color: #ac4b38;
        &::after {
          content: "";
          display: inline-block;
          width: 16px;
          height: 16px;
          margin-left: 2px;
          background: url("../../assets/images/order/more.png") no-repeat center
            center;
          background-size: cover;
          vertical-align: text-top;
        }
      }
      .no_coupon {
        color: #999;
      }
    }
    .charging_p2 {
      margin-top: 15px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      span {
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        float: right;
        color: #ac4b38;
      }
    }
  }
  .order_content {
    .dorctor_name {
      font-size: 14px;
    }
    .dorctor_time {
      margin-top: 4px;
      font-size: 12px;
      color: #999999;
    }
  }
  .submit_content {
    width: 100%;
    height: 70px;
    padding: 10px 15px;
    box-sizing: border-box;
    border-top: 1px solid #e4e4e4;
    .submit_money {
      font-size: 14px;
      line-height: 40px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      display: inline-block;
      span {
        font-weight: bold;
        font-size: 24px;
      }
    }
    .submit_button {
      border: none;
      width: 120px;
      height: 40px;
      background: rgba(172, 75, 56, 1);
      border-radius: 10px;
      text-align: center;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 25px;
      float: right;
    }
  }
  .express_content {
    background-color: #f8f8f8;
    .express_head {
      background-color: #fff;
      width: 100%;
      height: 60px;
      line-height: 60px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      font-size: 18px;
      text-align: center;
      position: relative;
      .express_cancel,
      .express_determine {
        display: inline-block;
        padding: 0px 15px;
        height: 60px;
        font-size: 14px;
        position: absolute;
        top: 0;
      }
      .express_cancel {
        color: #999;
        left: 0;
      }
      .express_determine {
        color: #ac4b38;
        right: 0;
      }
    }
    .express_ul {
      width: 100%;
      box-sizing: border-box;
      padding: 0px 15px;
      .express_li {
        width: 100%;
        height: 60px;
        border-radius: 8px;
        background: #fff;
        margin-top: 10px;
        box-sizing: border-box;
        padding: 15px 12px;
        display: flex;
        img {
          display: block;
          width: 30px;
          height: 30px;
        }
        p {
          width: calc(100% - 60px);
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          line-height: 16px;
          margin-left: 10px;
          span {
            color: #999;
            font-size: 12px;
          }
        }
        .pay_p {
          line-height: 30px;
        }
        .express_icon {
          width: 20px;
          height: 20px;
          background: url("../../assets/images/order/express_nor.png") no-repeat
            center center;
          background-size: cover;
          margin-top: 5px;
        }
        .express_icon_active {
          background: url("../../assets/images/order/express_pre.png") no-repeat
            center center;
          background-size: cover;
        }
      }
    }
  }
  .buynow {
    width: calc(100% - 40px);
    height: 48px;
    background: rgba(172, 75, 56, 1);
    border-radius: 10px;
    font-size: 18px;
    color: #fff;
    border: none;
    margin: 0 auto;
  }
  .submit_content .buynow {
    width: 100%;
  }
  .express_content .buynow {
    position: fixed;
    bottom: 10px;
    left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/medicineorderdetail.vue